import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95eb7a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex between" }
const _hoisted_4 = { class: "flex type-box" }
const _hoisted_5 = {
  key: 0,
  class: "flex color-box"
}
const _hoisted_6 = { class: "set-color" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "icon-choice-true" }

import { Radio } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import { reactive, ref } from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import { Condition } from '../../components/types';
import http from '@/api/conentCenter/portalDecoration';
import emitter from '@/utils/mitt';
import CLoading from '@/components/CLoading.vue';
import { emptyDataSec } from '@/assets';
import { colorList } from '../../components/PublicFunction';
interface iconInfo {
  id: number;
  icon: string;
  img_url: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  props: {
    dataSource: null
  },
  setup(__props: any) {

const props = __props as { dataSource: any };

const aRadioGroup = Radio.Group;
const activeKey = ref(1);
const selectType = ref(0);
const colorType = ref(1);
const condition = reactive<Condition>({
  iconTypes: [
    {
      label: '线性',
      value: 1,
    },
    {
      label: '单色',
      value: 2,
    },
    {
      label: '填充',
      value: 3,
    },
  ],
  selIconTypes: [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '办公',
      value: 1,
    },
    {
      label: '人物',
      value: 2,
    },
    {
      label: '表情',
      value: 3,
    },
    {
      label: '工业',
      value: 4,
    },
    {
      label: '医疗',
      value: 5,
    },
    {
      label: '其它',
      value: 9,
    },
  ],
  colorRadio: [
    { label: '默认', value: 1 },
    { label: '自定义', value: 2 },
  ],
  bgTypes: [
    {
      label: '素材图',
      value: 4,
    },
    {
      label: '插画',
      value: 5,
    },
  ],
  selBgTypes: [
    {
      label: '商务',
      value: 6,
    },
    {
      label: '金融',
      value: 7,
    },
    {
      label: '科技',
      value: 8,
    },
    {
      label: '工业',
      value: 4,
    },
    {
      label: '医疗',
      value: 5,
    },
    {
      label: '其它',
      value: 9,
    },
  ],
});
const color = ref(colorList.value[0]);
const oldColor = ref(colorList.value[0]);

const menuKey: any = ref(props.dataSource.menuKey);
menuKey.value == 4 ? ((activeKey.value = 4), (selectType.value = 0)) : '';

const changeColor = () => {
  var reg = new RegExp(oldColor.value, 'g');
  defaultIconList.value.map((e) => (e.icon = e.icon.replace(reg, color.value)));
  oldColor.value = color.value;
};

const defaultIconList = ref<iconInfo[]>([]);
const selectIconId = ref();
const showLoading = ref<boolean>(false);
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 24, // 每页条数
  totalSize: 1, // 总数
  options: ['24', '36', '48', '60'], // 选项
});
const getDefaultConfigList = () => {
  selectIconId.value = '';
  let params = {
    type: activeKey.value,
    sort: selectType.value,
    page: pageConfig.current,
    page_num: menuKey.value == 2 ? 24 : 15,
  };
  showLoading.value = true;
  http
    .get_default_config_list({ params })
    .then((res) => {
      defaultIconList.value = res.data.data.data;
      pageConfig.totalSize = res.data.data.total;
      pageConfig.current = res.data.data.current_page;
      showLoading.value = false;
      var reg = new RegExp('iconColor', 'g');
      defaultIconList.value.map((e) => e.icon && (e.icon = e.icon.replace(reg, color.value)));
    })
    .catch(() => {
      showLoading.value = false;
    });
};
getDefaultConfigList();

const emitCheck = (item: any) => {
  selectIconId.value = item.id;
  let arr: any = [];
  arr.push(item.icon ? item.icon : item.img_url);
  emitter.emit('selectIconOrBg', arr);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tabs", { between: menuKey.value == 4, flex: menuKey.value == 4, tabs_box: menuKey.value == 4 }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuKey.value == 2 ? condition.iconTypes : condition.bgTypes, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_button, {
            key: index,
            class: _normalizeClass({ active: activeKey.value == item.value }),
            onClick: ($event: any) => ((activeKey.value = item.value), getDefaultConfigList())
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(condition.selIconTypes, (i, j) => {
            return (_openBlock(), _createBlock(_component_a_button, {
              type: "text",
              key: j,
              class: _normalizeClass({ active: selectType.value == i.value }),
              onClick: ($event: any) => ((selectType.value = i.value), getDefaultConfigList())
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(i.label), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ]),
        (menuKey.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(" 颜色： "),
              _createVNode(_unref(aRadioGroup), {
                options: condition.colorRadio,
                value: colorType.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((colorType).value = $event))
              }, null, 8, ["options", "value"]),
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(color.value), 1),
                _createVNode(_unref(ElColorPicker), {
                  modelValue: color.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((color).value = $event)),
                  size: "mini",
                  predefine: _unref(colorList),
                  onChange: changeColor
                }, null, 8, ["modelValue", "predefine"])
              ], 512), [
                [_vShow, colorType.value == 2]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (showLoading.value)
      ? (_openBlock(), _createBlock(CLoading, {
          key: 0,
          style: {"height":"200px","padding-top":"120px"}
        }))
      : (defaultIconList.value.length == 0)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 1,
            class: "empty_wrap",
            image: _unref(emptyDataSec),
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["flex wrap", { img_box: menuKey.value == 3 || menuKey.value == 4 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultIconList.value, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["svg-item flex center", { img_item: menuKey.value == 3 || menuKey.value == 4, icon_choices: selectIconId.value == i.id }]),
                key: i.id,
                onClick: ($event: any) => (emitCheck(i))
              }, [
                (i.icon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: i.icon
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: i.img_url,
                      alt: ""
                    }, null, 8, _hoisted_9)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(CheckOutlined), { class: "icon" })
                ])
              ], 10, _hoisted_7))
            }), 128))
          ], 2)),
    _createVNode(_component_a_pagination, {
      "show-quick-jumper": "",
      total: pageConfig.totalSize,
      current: pageConfig.current,
      "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
      "page-size": pageConfig.pageSize,
      "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
      "show-less-items": "",
      onChange: _cache[4] || (_cache[4] = ($event: any) => (getDefaultConfigList()))
    }, null, 8, ["total", "current", "page-size"])
  ]))
}
}

})